import axios from 'axios';

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json',
        // 'Accept': 'application/json',  // Aceitar resposta JSON
        // 'Access-Control-Allow-Origin': '*',  // Permitir todas as origens (use '*' apenas em ambiente de desenvolvimento)
        // 'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS', // Métodos permitidos
        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization', // Cabeçalhos permitidos
    }
});

// Adiciona um interceptor para incluir o token nas requisições
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

export default api;
